module.exports = __webpack_public_path__ + "static/media/COS_MEDELA.26156f86.webp";